
export class TimetableItemBase {

   constructor(data) {
      this.weekday = data.weekday;
      this.setTimespan(data.hour, data.span);
      this.date = data.date;
   }

   setTimespan(hour, span) {
      this.hour = hour;
      this.span = span;
      this.hours = [];
      for (let i=hour; i<hour+span; ++i) this.hours.push(i);
   }

   setHours(hours) {
      this.hours = hours.slice();
      this.hour = hours.length > 0 ? hours[0] : 0;
      this.span = hours.length;
   }

   render(item, rooms, teachers, classes, titles, message, movedSymbol, elCourse, weekNumber, view, dm) {

      // MSS-Nachmittagsstunden abhängig von der Kalenderwoche als 'inaktiv' markieren


      if (item.hour > 6
         && item.span == 1
         && item.course && item.course.classes && item.course.classes.length
         && dm.getClass(item.course.classes[0])
         && dm.getClass(item.course.classes[0]).year > 10
         && (item.hour % 2) !== (weekNumber % 2)) {
         elCourse.classList.add('inactive');
      }

      if (view.type === 'teacher') {
         elCourse.innerHTML = `
            <div class="class">${classes}</div>
            <div class="title">${movedSymbol}${titles}</div>
            <div class="room">${rooms}</div>
            <div class="message">${message}</div>
            <div class="diagonal-line"></div>
         `;
      }
      else if (view.type === 'room') {
         elCourse.innerHTML = `
            <div class="teachers">${teachers}</div>
            <div class="title">${movedSymbol}${titles}</div>
            <div class="room">${classes}</div>
            <div class="message">${message}</div>
            <div class="diagonal-line"></div>
         `;
      }
      else if (view.type === 'class') {
         elCourse.innerHTML = `
            <div class="teachers">${teachers}</div>
            <div class="title">${movedSymbol}${titles}</div>
            <div class="room">${rooms}</div>
            <div class="message">${message}</div>
            <div class="diagonal-line"></div>
         `;
      }
      else {
         elCourse.innerHTML = `
            <div class="teachers">${teachers}</div>
            <div class="title">${movedSymbol}${titles}</div>
            <div class="room">${rooms}</div>
            <div class="message">${message}</div>
            <div class="diagonal-line"></div>
         `;
      }

   }

   removeAbsentItems(items, absentItems) {
      return items.slice().filter(item => !absentItems.includes(item));
   }

   static convertDavinciDate(date) {
      return date.slice(0,4) + '-' + date.slice(4,6) + '-' + date.slice(6,8);
   }


}